import { render, staticRenderFns } from "./BrandIntroSection.vue?vue&type=template&id=a077209a"
import script from "./BrandIntroSection.vue?vue&type=script&lang=ts"
export * from "./BrandIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./BrandIntroSection.vue?vue&type=style&index=0&id=a077209a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports